module.exports = __webpack_public_path__ + "img/logo2.47a7157e.png";